namespace TabAurous.ECommerce {
    export namespace ECommSalesService {
        export const baseUrl = 'ECommSales/ECommSales';

        export declare function Create(request: Serenity.SaveRequest<ECommSalesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommSalesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommSalesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Authorize(request: AuthorizationRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ECommInvoiceExportExcel(request: ECommInvoicePrintRequest, onSuccess?: (response: Common.ExcelGenerateResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommSales/ECommSales/Create",
            Update = "ECommSales/ECommSales/Update",
            Delete = "ECommSales/ECommSales/Delete",
            Retrieve = "ECommSales/ECommSales/Retrieve",
            List = "ECommSales/ECommSales/List",
            Authorize = "ECommSales/ECommSales/Authorize",
            ECommInvoiceExportExcel = "ECommSales/ECommSales/ECommInvoiceExportExcel"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Authorize', 
            'ECommInvoiceExportExcel'
        ].forEach(x => {
            (<any>ECommSalesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
